import React from 'react';
import { useLocation } from 'react-router-dom';

import { PaymentSuccess } from './components/PaymentSuccess';
import { Col, Row } from 'antd';
import useWindowSize from 'app/hooks/useWindowSize';

const PendingConfirm: React.FC = () => {
  const location = useLocation();
  const orderId = (location.state as any)?.orderId;

  const { device } = useWindowSize();

  return (
    <Row style={{ display: 'flex', justifyContent: 'center' }}>
      <Col span={device === 'desktop' ? 12 : 22}>
        <PaymentSuccess isPendingConfirm orderId={orderId} />
      </Col>
    </Row>
  );
};

export default PendingConfirm;
